export default {
  lang: {
    confirm: {
      title: '你確認要刪除呀? 刪除後將唔能再恢復',
      okText: '刪除',
      cancelText: '取消',
    },
  },
};
